import { createSelector } from '@ngrx/store';

export const getStreetTypesState = createSelector(
    (state: any) => state.streetTypes,
    (state: any) => state.get('list')
);

export const getCreateStreetTypeState = createSelector(
    (state: any) => state.streetTypes,
    (state: any) => state.get('createStreetType')
);

export const getUpdateStreetTypeState = createSelector(
    (state: any) => state.streetTypes,
    (state: any) => state.get('updateStreetType')
);
 